import {createStateMaker} from '@shared/helpers/object'

import {SearchState} from '../interfaces'

export const getInitialState = (): SearchState => ({
    selected: {
        keyword: '',
        startDate: '',
        endDate: '',
        categories: [],
        details: [],
    },
    date: {
        type: 'MAX',
        max: 'FIVE_YEAR',
    },
    category: {
        title: '',
        items: [],
    },
})

export const makeMock = createStateMaker<SearchState>(getInitialState)
